export default (activeAdminItem) => {
  switch(activeAdminItem) {
    case 'user-account':
      return {
        dataWrapperStateName: 'userAccountSortedData',
        colSortDirsStateName: 'userAccountColSortDirs'
      };
      // break;
    case 'user-role':
      return {
        dataWrapperStateName: 'userRoleSortedData',
        colSortDirsStateName: 'userRoleColSortDirs'
      };
    case 'user-group':
      return {
        dataWrapperStateName: 'userGroupSortedData',
        colSortDirsStateName: 'userGroupColSortDirs'
      };
    case 'supervisor-evaluation':
      return {
        dataWrapperStateName: 'supervisorEvaluationSortedData',
        colSortDirsStateName: 'supervisorEvaluationColSortDirs'
      };
    case 'repair-area':
      return {
        dataWrapperStateName: 'repairAreaSortedData',
        colSortDirsStateName: 'repairAreaColSortDirs',
        apiAdaptedDataStateName: 'repairAreaApiAdaptedData'
      };
    case 'repair-status':
      return {
        dataWrapperStateName: 'repairStatusSortedData',
        colSortDirsStateName: 'repairStatusColSortDirs',
        apiAdaptedDataStateName: 'repairStatusApiAdaptedData'
      };
    case 'repair-form-type':
      return {
        dataWrapperStateName: 'repairFormTypeSortedData',
        colSortDirsStateName: 'repairFormTypeColSortDirs',
        apiAdaptedDataStateName: 'repairFormTypeApiAdaptedData'
      };
    case 'repair-warranty-type':
      return {
        dataWrapperStateName: 'repairWarrantyTypeSortedData',
        colSortDirsStateName: 'repairWarrantyTypeColSortDirs',
        apiAdaptedDataStateName: 'repairWarrantyTypeApiAdaptedData'
      };
    case 'repair-product-from':
      return {
        dataWrapperStateName: 'repairProductFromSortedData',
        colSortDirsStateName: 'repairProductFromColSortDirs',
        apiAdaptedDataStateName: 'repairProductFromApiAdaptedData'
      };
    case 'repair-service-type':
      return {
        dataWrapperStateName: 'repairServiceTypeSortedData',
        colSortDirsStateName: 'repairServiceTypeColSortDirs',
        apiAdaptedDataStateName: 'repairServiceTypeApiAdaptedData'
      };
    case 'repair-owner-judgement':
      return {
        dataWrapperStateName: 'repairOwnerJudgementSortedData',
        colSortDirsStateName: 'repairOwnerJudgementColSortDirs',
        apiAdaptedDataStateName: 'repairOwnerJudgementApiAdaptedData'
      };
    case 'repair-currency':
      return {
        dataWrapperStateName: 'repairCurrencySortedData',
        colSortDirsStateName: 'repairCurrencyColSortDirs',
        apiAdaptedDataStateName: 'repairCurrencyApiAdaptedData'
      };
    case 'repair-service-satisfaction':
      return {
        dataWrapperStateName: 'repairServiceSatisfactionSortedData',
        colSortDirsStateName: 'repairServiceSatisfactionColSortDirs',
        apiAdaptedDataStateName: 'repairServiceSatisfactionApiAdaptedData'
      };
    case 'repair-issue-type':
      return {
        dataWrapperStateName: 'repairIssueTypeSortedData',
        colSortDirsStateName: 'repairIssueTypeColSortDirs',
        apiAdaptedDataStateName: 'repairIssueTypeApiAdaptedData'
      };
    case 'system-parameter-setting':
      return {
        dataWrapperStateName: 'systemParameterSettingSortedData',
        colSortDirsStateName: 'systemParameterSettingColSortDirs'
      };
    case 'company-introduction':
      return {
        dataWrapperStateName: 'companyIntroductionSortedData',
        colSortDirsStateName: 'companyIntroductionColSortDirs'
      };
    case 'company-zone':
      return {
        dataWrapperStateName: 'companyZoneSortedData',
        colSortDirsStateName: 'companyZoneColSortDirs'
      };
    case 'company-industry':
      return {
        dataWrapperStateName: 'companyIndustrySortedData',
        colSortDirsStateName: 'companyIndustryColSortDirs'
      };
    case 'company-trade':
      return {
        dataWrapperStateName: 'companyTradeSortedData',
        colSortDirsStateName: 'companyTradeColSortDirs'
      };
    case 'work-nature':
      return {
        dataWrapperStateName: 'workNatureSortedData',
        colSortDirsStateName: 'workNatureColSortDirs'
      };
    case 'work-progress':
      return {
        dataWrapperStateName: 'workProgressSortedData',
        colSortDirsStateName: 'workProgressColSortDirs'
      };
    case 'project-progress':
      return {
        dataWrapperStateName: 'projectProgressSortedData',
        colSortDirsStateName: 'projectProgressColSortDirs'
      };
    case 'media-cloud-file-attribute':
      return {
        dataWrapperStateName: 'mediaCloudFileAttributeSortedData',
        colSortDirsStateName: 'mediaCloudFileAttributeColSortDirs'
      };
    case 'media-cloud-file-attribute-value':
      return {
        dataWrapperStateName: 'mediaCloudFileAttributeValueSortedData',
        colSortDirsStateName: 'mediaCloudFileAttributeValueColSortDirs'
      };
    case 'news-type':
      return {
        dataWrapperStateName: 'newsTypeSortedData',
        colSortDirsStateName: 'newsTypeColSortDirs',
        apiAdaptedDataStateName: 'newsTypeApiAdaptedData'
      };
    default:
      
  };
};


// WEBPACK FOOTER //
// ./src/salesky/routes/newAdmin/getAdminItemStateName.js